<script setup lang="ts">
import ModalFeesInfo from './ModalFeesInfo.vue'
import { FeesBlockType } from '~/lib/services/store/catalog/cart.dtos'

const props = withDefaults(
  defineProps<{
    feesBlock: FeesBlockType
    serviceFee?: string
    smallOrderFee?: string
  }>(),
  {
    serviceFee: undefined,
    smallOrderFee: undefined,
  }
)

const { t } = useLocale()
const { format } = useFormatAmount()

const feesNames = computed(() => ({
  serviceFee: props.serviceFee,
  smallOrderFee: props.smallOrderFee,
}))

const showFeesInfoModal = ref<Boolean>(false)

const showMultipleFeesAction = computed(() => Object.entries(props.feesBlock).length > 1)

const toggleFeesInfoModal = () => {
  showFeesInfoModal.value = !showFeesInfoModal.value
}
</script>

<template>
  <div class="flex flex-col gap-[14px] text-sm">
    <div
      v-for="[key, amount] in Object.entries(feesBlock)"
      :key="key"
      :data-test="`cart-amount-row--${key}`"
      class="flex flex-row items-center justify-between text-mcd-secondaryDarkGrey"
    >
      <template v-if="key === 'serviceFee' || key === 'smallOrderFee'">
        <Fee
          :name="feesNames[key]"
          :fee-type="key"
          :amount="amount"
          :show-tooltip="!showMultipleFeesAction"
        />
      </template>
      <template v-else>
        <p>
          {{ t(`shoppingCart.${key}`) }}
        </p>
        <span class="block">{{ format(amount) }}</span>
      </template>
    </div>
    <div
      v-if="showMultipleFeesAction"
      class="flex flex-row items-center gap-2"
      data-test="modal-fees-row"
      @click="toggleFeesInfoModal"
    >
      <p class="cursor-pointer text-mcd-link">
        {{ t('shoppingCart.actions.multipleFees') }}
      </p>
      <Chevron class="h-4" />
    </div>
    <ModalFeesInfo v-if="showFeesInfoModal" @toggle-modal="toggleFeesInfoModal" />
  </div>
</template>
